// 768px is a common value for tablet breakpoints, not necessarily desktop breakpoints. But in this instance, it is
// being used to include devices that have sufficient width for a desktop layout.
const MIN_DESKTOP_LAYOUT_WIDTH = 768;

/**
 * Non-exhaustive check for mobile devices. If `navigator.userAgentData.mobile` is available, it will be used.
 *
 * Otherwise, the user agent string will be checked for common mobile device strings AND the device will be checked
 * for touch support. This should eliminate false positives on Chromebooks running Android and Windows laptops with
 * touchscreens.
 * @return Whether the device is _probably_ a mobile device.
 */
const isMobile = (): boolean => {
  const isTouch = navigator.maxTouchPoints > 0;
  // @ts-ignore - userAgentData is not yet in the TS types
  return (navigator?.userAgentData?.mobile || /Android|Mac|Windows Phone/.test(navigator.userAgent)) && isTouch;
};

/**
 * Indicates if the user's device has sufficient width to display a desktop layout.
 */
const useDesktopLayout = () => window.innerWidth >= MIN_DESKTOP_LAYOUT_WIDTH;

export {
  isMobile,
  useDesktopLayout,
};
